<template>
  <span v-show="$store.getters['app/overlays'].show_start_selector_overlay">
    <img v-if="show_alert" draggable="false" id="text_background_many" src="./../assets/images/Asset 55.png" alt="">

    <span v-else>
      <span id="true_counter_text">Gevonden: <span v-html="good_counter"></span>/<span v-html="items.length"></span></span>
      <span id="false_counter_text">Fout: <span v-html="wrong_counter"></span></span>
      <img draggable="false" @click="goToHome()" id="top_quit_btn" src="./../assets/images/Asset 31.png" alt="">

      <div id="inner_container" v-if="render == 1">
        <img id="bucket" v-on:drop="drop($event, 'trash')" v-on:dragover="allowDrop($event)" src="./../assets/images/bucket.png" alt="">
        <img id="net" v-on:drop="drop($event, 'not_trash')" v-on:dragover="allowDrop($event)" src="./../assets/images/net.png" alt="">

        <span v-for="(item) in items" :key="item.id">
          <img v-if="item.id == 40" class="clickable trash" id="trash_40" src="./../assets/images/Asset 40.png" draggable="true" v-on:dragstart="drag($event)">
          <img v-if="item.id == 41" class="clickable trash" id="trash_41" src="./../assets/images/Asset 41.png" draggable="true" v-on:dragstart="drag($event)">
          <img v-if="item.id == 42" class="clickable trash" id="trash_42" src="./../assets/images/Asset 42.png" draggable="true" v-on:dragstart="drag($event)">
          <img v-if="item.id == 43" class="clickable trash" id="trash_43" src="./../assets/images/Asset 43.png" draggable="true" v-on:dragstart="drag($event)">
          <img v-if="item.id == 44" class="clickable trash" id="trash_44" src="./../assets/images/Asset 44.png" draggable="true" v-on:dragstart="drag($event)">
          <img v-if="item.id == 45" class="clickable trash" id="trash_45" src="./../assets/images/Asset 45.png" draggable="true" v-on:dragstart="drag($event)">
          <img v-if="item.id == 46" class="clickable trash" id="trash_46" src="./../assets/images/Asset 46.png" draggable="true" v-on:dragstart="drag($event)">
          <img v-if="item.id == 47" class="clickable trash" id="trash_47" src="./../assets/images/Asset 47.png" draggable="true" v-on:dragstart="drag($event)">
          <img v-if="item.id == 48" class="clickable trash" id="trash_48" src="./../assets/images/Asset 48.png" draggable="true" v-on:dragstart="drag($event)">
          <img v-if="item.id == 49" class="clickable trash" id="trash_49" src="./../assets/images/Asset 49.png" draggable="true" v-on:dragstart="drag($event)">
          <img v-if="item.id == 50" class="clickable trash" id="trash_50" src="./../assets/images/Asset 50.png" draggable="true" v-on:dragstart="drag($event)">
          <img v-if="item.id == 52" class="clickable trash" id="trash_52" src="./../assets/images/Asset 52.png" draggable="true" v-on:dragstart="drag($event)">
          <img v-if="item.id == 53" class="clickable trash" id="trash_53" src="./../assets/images/Asset 53.png" draggable="true" v-on:dragstart="drag($event)">
          <img v-if="item.id == 54" class="clickable trash" id="trash_54" src="./../assets/images/Asset 54.png" draggable="true" v-on:dragstart="drag($event)">
          <img v-if="item.id == 55" class="clickable trash" id="trash_55" src="./../assets/images/Asset 41.png" draggable="true" v-on:dragstart="drag($event)">
          <img v-if="item.id == 56" class="clickable trash" id="trash_56" src="./../assets/images/Asset 41.png" draggable="true" v-on:dragstart="drag($event)">
        </span>
      </div>
    </span>
  </span>
</template>

<script>
import swal from 'sweetalert2'

export default {
  name: "Hengelen",
  mounted() {
    let that = this
    setTimeout(function() {
      that.show_alert = false
    }, 5000)
  },

  created() {},
  destroyed() {},

  data() {
    return {
      good_counter: 0,
      wrong_counter: 0,
      show_alert: true,
      render: 1,

      items: [
        {
          id: 40,
          intended: 'trash',
        },
        {
          id: 41,
          intended: 'not_trash',
        },
        {
          id: 42,
          intended: 'trash',
        },
        {
          id: 43,
          intended: 'trash',
        },
        {
          id: 44,
          intended: 'trash',
        },
        {
          id: 45,
          intended: 'trash',
        },
        {
          id: 46,
          intended: 'trash',
        },
        {
          id: 47,
          intended: 'trash',
        },
        {
          id: 48,
          intended: 'trash',
        },
        {
          id: 49,
          intended: 'trash',
        },
        {
          id: 50,
          intended: 'trash',
        },
        {
          id: 52,
          intended: 'not_trash',
        },
        {
          id: 53,
          intended: 'trash',
        },
        {
          id: 54,
          intended: 'not_trash',
        },
        {
          id: 55,
          intended: 'not_trash',
        },
        {
          id: 56,
          intended: 'not_trash',
        },
      ]
    };
  },

  methods: {
    resetGame() {
      this.good_counter = 0;
      this.wrong_counter = 0;
      this.show_alert = true;
      this.render = 0;

      let that = this
      setTimeout(function() {
        that.render = 1
        that.show_alert = false
      }, 5000)
    },

    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
    },

    gameEnd() {
      var that = this
      new swal({
          allowEscapeKey: false,
          allowOutsideClick: false,
          title: "",
          html: `<p class='swal_html'>Goed zo!</p>`,
          type: "success",
          showCancelButton: true,
          cancelButtonColor: '#d33',
          cancelButtonText: 'Terug',
          confirmButtonColor: "#9BCB3C",
          confirmButtonText: "Opnieuw spelen",
        }).then(function (confirm) {
          if ( confirm.isConfirmed ) {
            that.resetGame()
          } else {
            that.goToHome()
          }
        });
    },

    allowDrop(event) {
      event.preventDefault();
    },

    drag(event) {
      event.dataTransfer.setData("text", event.target.id);
    },

    drop(event, intended_drop) {
      event.preventDefault();
      var data = event.dataTransfer.getData("text"),
          id = data.replace('trash_', '');
      event.target.appendChild(document.getElementById(data));

      for (let index = 0; index < this.items.length; index++) {
        const element = this.items[index];
        if ( element.id == id ) {
          if ( element.intended == intended_drop ) {
            this.good_counter++;
          } else {
            this.wrong_counter++;
          }
        }
      }
    },
  },

  watch: {
    good_counter: function (counter) {
      console.log("Good: " + this.good_counter);
      console.log("wrong: " + this.wrong_counter);
      if ( ( (this.good_counter + this.wrong_counter) ) == this.items.length ) {
        this.gameEnd()
      }
    },
    wrong_counter: function (counter) {
      console.log("Good: " + this.good_counter);
      console.log("wrong: " + this.wrong_counter);
      if ( ( (this.good_counter + this.wrong_counter) ) == this.items.length ) {
        this.gameEnd()
      }
    },
  },
  computed: {
    myGoodCounter: function () {
      return this.good_counter
    }
  }
};
</script>

<style>
  #true_counter_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 3%;
    left: 2%;
    color: #739033;
    z-index: 1;
    width: 37%;
    font-size: 3.5vw;
  }

  #false_counter_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 7%;
    left: 2%;
    color: #ff0000;
    z-index: 1;
    width: 12%;
    font-size: 3.5vw;
  }

  @font-face {
    font-family: "LuckiestGuy";
    src: url('./../assets/fonts/LuckiestGuy-Regular.ttf') format('truetype');
  }

  .trash {
    opacity: 0.2;
    position: absolute;
  }

  button {
    cursor: url('./../assets/cursor/fishing-tool.png'), default;
  }

  .trash:hover {
    opacity: 1;
    cursor: url('./../assets/cursor/fishing-tool.png'), default;
  }

  #trash_40 {
    margin-top: 32%;
    left: 5%;
    width: 9%;
  }

  #trash_41 {
    margin-top: 39%;
    left: 14%;
    width: 13%;
  }

  #trash_42 {
    margin-top: 38%;
    left: 30%;
    width: 9%;
  }

  #trash_43 {
    margin-top: 33%;
    left: 45%;
    width: 9%;
  }

  #trash_44 {
    margin-top: 40%;
    left: 45%;
    width: 9%;
  }

  #trash_45 {
    margin-top: 47%;
    left: 5%;
    width: 9%;
  }

  #trash_46 {
    margin-top: 33%;
    left: 20%;
    width: 9%;
  }

  #trash_47 {
    margin-top: 35%;
    left: 55%;
    width: 9%;
  }

  #trash_48 {
    margin-top: 38%;
    left: 3%;
    width: 5%;
  }

  #trash_49 {
    margin-top: 37%;
    left: 85%;
    width: 4%;
  }

  #trash_50 {
    margin-top: 32.5%;
    left: 35%;
    width: 6%;
  }
  
  #trash_52 {
    margin-top: 45%;
    left: 24%;
    width: 15%;
  }

  #trash_53 {
    margin-top: 31.5%;
    left: 60%;
    width: 12%;
  }

  #trash_54 {
    margin-top: 38%;
    left: 70%;
    width: 12%;
  }

  #trash_55 {
    margin-top: 35%;
    left: 88%;
    width: 12%;
  }
  #trash_56 {
    margin-top: 28.5%;
    left: 76%;
    width: 12%;
  }

  #bucket {
    position: absolute;
    left: 5%;
    margin-top: 12%;
    rotate: 35deg;
    width: 10%;
    -webkit-filter: drop-shadow(5px 5px 5px #8f8f8f);
    filter: drop-shadow(5px 5px 5px #8f8f8f);
  }
  #net {
    position: absolute;
    left: 25%;
    margin-top: 5%;
    rotate: 45deg;
    width: 10%;
    -webkit-filter: drop-shadow(5px 5px 5px #8f8f8f);
    filter: drop-shadow(5px 5px 5px #8f8f8f);
  }

  #bucket:hover {
    animation-name: shake_bucket;
    animation-duration: 0.5s;
  }

  #net:hover {
    animation-name: shake_net;
    animation-duration: 0.5s;
  }

  @keyframes shake_net {
    0% {
      rotate: 45deg;
    }
    50% {
      rotate: 65deg;
    }
    100% {
      rotate: 45deg;
    }
  }

  @keyframes shake_bucket {
    0% {
      rotate: 35deg;
    }
    50% {
      rotate: 55deg;
    }
    100% {
      rotate: 35deg;
    }
  }

  #inner_container {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    /* cursor: url('./../assets/cursor/fishing-tool.png'), default; */
  }
</style>


